import React from 'react';
import { Formik, Form, Field } from 'formik';

import { useToast, GridItem, Grid, Heading, Box, Input, Select, Button } from '@chakra-ui/react';

import DatePicker from 'components/datePicker/DatePicker';

import { useParams } from 'react-router-dom';

import * as Yup from 'yup';

import xhr from 'xhr';

import QuillEditor from 'components/editorQuill';

export default function InsertText(props) {
  const [value, setValue] = React.useState('');
  const { dataMaterials, select, setIsOpen } = props;
  const params = useParams();

  const toast = useToast();

  const [dateFilter, setDateFilter] = React.useState(null);

  const [dateFilterEnd, setDateFilterEnd] = React.useState(null);

  const handleDateChange = (date) => {
    setDateFilter(date);
  };

  const handleDateChangeEnd = (date) => {
    setDateFilterEnd(date);
  };

  const [loadingButton, setLoadingButton] = React.useState(false);

  const handleVideo = async (values, action) => {
    try {
      setLoadingButton(true);

      if (value == '') return alert('el texto está vacio');

      const responseText = await xhr.post(`/texts/`, {
        data: {
          title: values.title,
          content: value,
        },
      });

      setValue('');

      const response = await xhr.post(`/materials/`, {
        data: {
          ...values,
          text: responseText.data.data.id,
          module: params.idModule,
          type: select,
          enabled_date: dateFilter,
          enabled_date_end: dateFilterEnd,
        },
      });

      const getPopulate = await xhr(`/materials/${response.data.data.id}?populate=*`);

      toast({
        title: 'El material se creo correctamente!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      dataMaterials(getPopulate.data.data);
      setIsOpen(false);

      action.resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingButton(false);
    }
  };

  const RequerimentSchema = Yup.object().shape({
    title: Yup.string().required('Requerido'),
    order: Yup.string().required('Requerido'),
    duration: Yup.string().required('Requerido'),
  });

  return (
    <Box>
      <Formik
        enableReinitialize
        initialValues={{
          title: '',
          order: '',
          duration: '',
        }}
        validationSchema={RequerimentSchema}
        onSubmit={handleVideo}
      >
        <Form>
          <Grid templateColumns="repeat(12, 1fr)" gap={6}>
            <GridItem colSpan={4}>
              <Box marginTop="20px">
                <Heading use="h3" width="100%">
                  Material
                </Heading>
              </Box>
              <Grid marginTop="20px" gap={4}>
                <GridItem colSpan={6}>
                  <Box>Título</Box>
                  <Field marginTop="20px" as={Input} name="title" />
                </GridItem>

                <GridItem colSpan={3}>
                  <Box>Orden</Box>
                  <Field marginTop="20px" as={Input} type="number" name="order" />
                </GridItem>

                <GridItem colSpan={3}>
                  <Box>Duración</Box>
                  <Field marginTop="20px" as={Input} type="number" name="duration" />
                </GridItem>

                <GridItem colSpan={6}>
                  <Box color="#636363">Periodo</Box>
                  <Field marginTop="20px" name="period" as={Select}>
                    <option value=""></option>
                    <option value="primer">primer</option>
                    <option value="segundo">segundo</option>
                    <option value="tercer">tercer</option>
                    <option value="cuarto">cuarto</option>
                  </Field>
                </GridItem>

                <GridItem colSpan={12}>
                  <br />
                  <Box color="#636363">Fecha Inicio</Box>
                  <DatePicker date={dateFilter} placeholder="Fecha Inicio" onChange={handleDateChange} />
                  <br />
                  <Box color="#636363">Fecha Fin</Box>
                  <DatePicker date={dateFilterEnd} placeholder="Fecha Fin" onChange={handleDateChangeEnd} />

                  <br />
                </GridItem>
              </Grid>
            </GridItem>

            <GridItem colSpan={8} marginTop="30px" borderLeft="1px solid" borderColor="gray.200" paddingLeft="20px">
              <Box marginBottom="20px" position="relative" top="-10px">
                <Heading use="h3" width="100%">
                  Texto
                </Heading>
              </Box>

              <Box marginTop="20px">Texto</Box>
              <QuillEditor value={value} setValue={setValue} />
            </GridItem>
          </Grid>

          <Button
            type="submit"
            colorScheme="#574feb"
            bg="#574feb"
            marginY="10px"
            marginX="10px"
            width="140px"
            isLoading={loadingButton}
          >
            Crear
          </Button>
        </Form>
      </Formik>
    </Box>
  );
}
